// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: apps/client/src/world/spaces/*.ts
import * as m0 from './spaces/museum';
import * as m1 from './spaces/out';
import * as m2 from './spaces/room';
import * as m3 from './spaces/shop';
import * as m4 from './spaces/vroom';
export const spaceModules = [m0, m1, m2, m3, m4] as const;
